import { IconButton } from "@mui/material";
// import { ArrowUpwardIcon, ArrowDownwardIcon } from "../icons/index.tsx";
import "../styles/datagridStyle.css";
import { DataGrid } from "@mui/x-data-grid";
import { useRecoilState, useRecoilValue } from "recoil";
import { queryOptionsState, selectedMenuState } from "../recoil/index.ts";
import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ArrowUpwardIcon } from "../icons/index.tsx";

// 연속적인 요청 막기
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export const fieldOptions = {
  공지사항: ["id", "title", "content", "user_name", "update_at"],
  사용자: ["id", "user_id", "name", "authority", "is_admin", "approval_status"],
  "Data Set": ["id", "name", "total_labeled_files"],
  베이스모델: ["id", "name"],
  모델: ["id", "name"],
  검사규칙: ["id", "model_name", "recipe_regex", "image_regex"],
  검사현황: ["id", "client_ip", "name", "material_name", "label", "create_at"],
  학습: ["id", "name"],
  "시스템 로그": ["id", "level", "message", "timestamp"],
  "학습 로그": ["id", "create_at", "info", "train_uuid"],
};

export const CustomDataGrid = ({
  rows,
  uuid,
  columns,
  onRowClick,
  ...otherProps
}) => {
  const selectedMenu = useRecoilValue(selectedMenuState);
  const [columnResize, setColumnResize] = useState(() => {
    const savedColumnResize = localStorage.getItem("columnResize");
    return savedColumnResize ? JSON.parse(savedColumnResize) : {};
  });
  const userData = localStorage.getItem("userData");
  const userObject = JSON.parse(userData);

  const [queryOption, setQueryOption] = useRecoilState(queryOptionsState);

  const handleSortClick = () => {
    console.log("click");
  };

  const handleHeaderClick = (field) => {
    console.log(field);
    let sort = "asc";
    if (queryOption.sort === "asc") {
      sort = "desc";
      setQueryOption((prev) => ({
        ...prev,
        sort_type: field,
        sort: sort,
        page: 1,
      }));
    } else {
      sort = "asc";
      setQueryOption((prev) => ({
        ...prev,
        sort_type: field,
        sort: sort,
        page: 1,
      }));
    }
  };

  const handleColumnResize = (params) => {
    const { field, width } = params.colDef;
    setColumnResize((prev) => ({
      ...prev,
      [selectedMenu]: {
        ...prev[selectedMenu],
        [field]: width,
      },
    }));
  };

  const saveToLocalStorage = useCallback(
    debounce(async (resizeData) => {
      localStorage.setItem("columnResize", JSON.stringify(resizeData));

      // setTimeout(async () => {
      //   try {
      //     const response = await editUser(userObject.id, {
      //       column_size: resizeData,
      //     });
      //     console.log(response);
      //   } catch (error) {
      //     handleError(error);
      //   }
      // }, 1000);
    }, 500),
    []
  );

  useEffect(() => {
    saveToLocalStorage(columnResize);
  }, [columnResize]);

  const getColumnWidth = (field, defaultWidth) => {
    return (
      (columnResize[selectedMenu] && columnResize[selectedMenu][field]) ||
      defaultWidth
    );
  };

  const selectedFields = fieldOptions[selectedMenu];

  return (
    <Box>
      <DataGrid
        rows={rows}
        columns={columns.map((col, index) => ({
          ...col,
          width: getColumnWidth(col.field, col.width),
          resizable: index !== columns.length - 1,
          renderHeader: (params) => (
            <div className="datagrid-head-container">
              <span>{params.colDef.headerName}</span>
              {selectedFields && selectedFields.includes(col.field) && (
                <IconButton
                  className="datagrid-sort-button"
                  onClick={() => handleHeaderClick(params.field)}
                >
                  <ArrowUpwardIcon sx={{ fontSize: "15px" }} />
                  {/* button */}
                </IconButton>
              )}
            </div>
          ),
        }))}
        disableRowSelectionOnClick
        disableExtendRowFullWidth
        disableColumnSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        hideFooter
        onRowClick={onRowClick}
        onSortModelChange={handleSortClick}
        onColumnResize={handleColumnResize}
        getRowClassName={(params) => {
          if (!uuid) return;
          return params.row.uuid === uuid ? "highlighted-row" : "";
        }}
        sx={{
          border: "1px solid var(--dashboard-line-color) !important",
          "--DataGrid-rowBorderColor": "transparent",
          "--unstable_DataGrid-overlayBackground": "var(--td-color)",
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              background: "var(--th-color)",
            },
          "& .MuiDataGrid-root": {
            overflowX: "auto",
            "--DataGrid-rowBorderColor": "transparent",
          },
          "& .MuiContainer-root": {
            position: "fixed", //이렇게 하면 전체 부모에서 fixed됨..
          },
          "& .MuiDataGrid-virtualScroller": {
            // height: "fit-content"
          },
          "& .MuiDataGrid-scrollbar--vertical": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "var(--th-color)",
          },
          "& .MuiDataGrid-scrollbarFiller--header": {
            backgroundColor: "var(--th-color)",
          },
          "& .MuiDataGrid-scrollbarFiller--borderTop": {
            borderTop: "none",
          },
          "& .MuiDataGrid-scrollbarFiller": {
            display: "none",
          },
          "& .MuiDataGrid-filler": {
            backgroundColor: "var(--th-color)",
            display: "none",
          },
          "& .MuiDataGrid-row": {
            cursor:
              selectedMenu === "시스템 로그" || selectedMenu === "학습 로그"
                ? ""
                : "pointer",
            backgroundColor: "var(--row-color)",
            color: "var(--text-color)",
          },
          "& .MuiDataGrid-row.highlighted-row": {
            backgroundColor: "var(--highlight-color, #e3f2fd)",
            "&:hover": {
              backgroundColor: "var(--highlight-hover-color, #cde8ffff)",
            },
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
            borderBottom: "1px solid var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "var(--text-color)",
          },
          "& .MuiTablePagination-root": {
            color: "var(--text-color)",
          },
          "& .MuiSvgIcon-root": {
            color: "var(--text-color)",
          },
          "& .MuiDataGrid-overlayWrapper": {
            minHeight: "30vh",
          },
        }}
        {...otherProps}
      />
    </Box>
  );
};
